/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Regional restriction for tournament participation
 * @export
 */
export const TournamentRegion = {
    NA: 'NA',
    EU: 'EU',
    APAC: 'APAC',
    SA: 'SA',
    OCE: 'OCE',
    GLOBAL: 'GLOBAL'
} as const;
export type TournamentRegion = typeof TournamentRegion[keyof typeof TournamentRegion];


export function instanceOfTournamentRegion(value: any): boolean {
    for (const key in TournamentRegion) {
        if (Object.prototype.hasOwnProperty.call(TournamentRegion, key)) {
            if (TournamentRegion[key as keyof typeof TournamentRegion] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TournamentRegionFromJSON(json: any): TournamentRegion {
    return TournamentRegionFromJSONTyped(json, false);
}

export function TournamentRegionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentRegion {
    return json as TournamentRegion;
}

export function TournamentRegionToJSON(value?: TournamentRegion | null): any {
    return value as any;
}

export function TournamentRegionToJSONTyped(value: any, ignoreDiscriminator: boolean): TournamentRegion {
    return value as TournamentRegion;
}

